import { SvgIconOwnProps } from '@mui/material';
import get from 'lodash/get';

const iconSizes: Record<Exclude<SvgIconOwnProps['size'], undefined>, number> = {
    tiny: 12,
    small: 16,
    medium: 20,
    large: 24,
};

export const svgIconTheme = {
    styleOverrides: {
        root: ({ ownerState, theme }) => ({
            ...(!!ownerState.color && {
                color: get(theme.palette, ownerState.color),
            }),
            ...(!!ownerState.size && {
                height: iconSizes[ownerState.size],
                width: iconSizes[ownerState.size],
            }),
        }),
    },
};
